import React from "react";

const FormField = ({ field, value, onChange }) => {
  return (
    <div className="flex flex-col">
      <label className="mb-2 font-medium text-gray-700">
        {field.label}
        {field.required && <span className="text-red-500"> *</span>}
      </label>
      <input
        type={field.type}
        name={field.label}
        value={value}
        onChange={onChange}
        required={field.required}
        className="border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>
  );
};

export default FormField;
